module.exports = __webpack_public_path__ + "LatoLatin-LightItalic.0e1583679fdd9bc5407f.woff";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-LightItalic.woff
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-LightItalic.woff
// module chunks = styles